module.exports = __webpack_public_path__ + "static/media/ring-line-2-top.4d89361a.svg";